import { Badge } from "@/components/ui/badge";
import { PRIORITIES, STAGE_STATUS_LABELS, WO_STATUS_LABELS } from "@/types/production";

type V = "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "blue";
const WO: Record<string, V> = { PLANNED: "secondary", IN_PROGRESS: "blue", COMPLETED: "success", CLOSED: "outline", CANCELLED: "outline" };
const ST: Record<string, V> = { PENDING: "outline", IN_PROGRESS: "blue", DONE: "success", SKIPPED: "secondary" };

export function WorkOrderStatusBadge({ status }: { status: string }) {
  return <Badge variant={WO[status] || "outline"}>{WO_STATUS_LABELS[status] || status}</Badge>;
}

export function StageStatusBadge({ status }: { status: string }) {
  return <Badge variant={ST[status] || "outline"}>{STAGE_STATUS_LABELS[status] || status}</Badge>;
}

/** Shown for High and Urgent only; Normal and Low need no flag */
export function PriorityBadge({ priority }: { priority: string }) {
  if (priority === "URGENT") return <Badge variant="destructive">{PRIORITIES.URGENT}</Badge>;
  if (priority === "HIGH") return <Badge variant="warning">{PRIORITIES.HIGH}</Badge>;
  return null;
}
